import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { publishTimetable } from 'src/api/publishTimetable/publishTimetable';
import { IPublishTimetableRequestBody, IPublishTimetableResponseBody } from 'src/api/publishTimetable/types';

type Options = Omit<
  UseMutationOptions<IPublishTimetableResponseBody, unknown, IPublishTimetableRequestBody, unknown>,
  'mutationFn'
>;

export const usePublishTimetable = (timetableId: string, options: Options = {}) => {
  return useMutation((payload: IPublishTimetableRequestBody) => publishTimetable(timetableId, payload), options);
};
